import { useMutation } from "@tanstack/react-query";

import { CONSOLE_API_ROUTES } from "@/config/apiConfig";
import consoleAxios from "@/service/axios/consoleAxios";

interface body {
    notice: string;
    idx: number;
    category: number;
}

// 게시글 공지설정
export const usePutBoardNotice = () => {
    return useMutation({
        mutationFn: async (body: body) => {
            const res = await consoleAxios.put(CONSOLE_API_ROUTES.BOARD_NOTICE, body);
            return res.data;
        },
    });
};
